<template>
  <ProSpaceGeoLayout>
    <template #top>
      <ProSpaceTopPanel :header="$t('users')">
        <template #right>
          <ProSpaceIconButton
            icon="update"
            @click="actionUpdate"
            iconWidth="16px"
            iconHeight="16px"
            containerSize="20px"
          />
          <ProSpaceDots
            style="margin-left: 15px"
            :options="dotsHeaderOptions"
            :isSquare="true"
            @action="(action) => handleHeaderDots(action)"
          />
          <ProSpaceButton
            style="margin-left: 15px"
            type="primary"
            icon="plus"
            :label="$t('newTxt')"
            @click="showChangeModal"
          />
        </template>
      </ProSpaceTopPanel>
    </template>
    <template #center>
      <ProSpaceGeoLayout>
        <template #top>
          <ProSpaceFilterPanel
            :searchPlaceholder="$t('searchTxt')"
            :modelFastFilter="modelFastFilter"
            :fastFilters="fastFilters"
            :txtResetFilters="$t('txtResetFilters')"
            :unicKeyStorage="userService.constructor.name + 'grid'"
            @apply="submitFilter"
            @update:modelFastFilter="
              (val) => {
                modelFastFilter = val;
              }
            "
            ref="filterPanel"
            :filter-model="[
              'firstName',
              'secondName',
              'lastName',
              'login',
              'email',
            ]"
            :blocked-filters="needBlock"
            @block="selectedMultipleBlockFilterHandler"
          >
            <template #hint> {{ $t("filterBy") }}</template>
            <template #filters="{ filter }">
              <ProSpaceMultiSelect
                :localization="$t"
                v-model="filter.status"
                :service="statusService"
                getMethod="get"
                optionLabel="text"
                optionValue="status"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :placeholderValue="$t('status')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearFilterTxt')"
                :searchPlaceholder="$t('searchTxt')"
                @apply="emitFilter"
              />
              <ProSpaceMultiSelect
                :localization="$t"
                v-model="filter.agencyLinkType"
                :service="userService"
                getMethod="getTypes"
                optionLabel="text"
                optionValue="value"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :placeholderValue="$t('userType')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearFilterTxt')"
                @apply="emitFilter"
              />
              <ProSpaceFilterSearchfield
                v-model="filter.agencyLinkAgencyId"
                :service="agencyService"
                :txtTitleModal="$t('agency')"
                get-method="grid"
                option-label="value"
                option-value="id"
                :placeholder-value="$t('agency')"
                :selectAllTxt="$t('selectAllTxt')"
                :cancelTxt="$t('cancelTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearFilterTxt')"
                @apply="emitFilter"
                :default-filter="{
                  disabled: false,
                }"
              />
              <ProSpaceFilterContainsChips
                v-model="filter.comments"
                :placeholder-value="$t('comments')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :clearFilterTxt="$t('clearFilterTxt')"
                @apply="emitFilter"
              />
              <ProSpaceCustomFilterPanel
                :customTxt="$t('custom')"
                :customFilterTxt="$t('customFilterTxt')"
                :clearFilterTxt="$t('clearFilterTxt')"
                :selectAllTxt="$t('selectAllTxt')"
                :closeTxt="$t('closeTxt')"
                :applyTxt="$t('applyTxt')"
                :fromTxt="$t('fromTxt')"
                :toTxt="$t('toTxt')"
                :services="customServices"
                :unicKeyStorage="userService.constructor.name + 'grid'"
                @apply="(model) => customFilterApply(filter, model)"
              />
            </template>
          </ProSpaceFilterPanel>
        </template>
        <template #center>
          <ProSpaceMainGrid
            ref="grid"
            class="users-grid"
            getMethod="grid"
            defaultSortField="createdAt"
            :defaultSortOrder="-1"
            :service="userService"
            :noMountedRequest="true"
            :selectionMode="isDeletedTab ? 'single' : 'multiple'"
            @selected-change="selectedHandler"
            @db-click="toItem"
            @loaded="onLoadGrid"
          >
            <template #columns>
              <Column
                field="fullName"
                :header="$t('user')"
                sortable
                headerClass="move-sort-head"
                style="flex: 1 1 20%"
              >
                <template #body="field">
                  <ProSpaceTableHeaderCell
                    v-if="field.data"
                    :id="field.data.id"
                    @click-on-title="toItem(field.data)"
                    :status="getStatus(field.data.status)"
                    :title="
                      field.data.secondName
                        ? `${field.data.lastName} ${field.data.firstName} ${field.data.secondName}`
                        : `${field.data.lastName} ${field.data.firstName}`
                    "
                    :description="`${field.data.agencyLinkAgencyValue || $t('mars')}`"
                  />
                </template>
              </Column>
              <Column field="email" :header="$t('holderEmail')" sortable>
                <template #body="field">
                  <ProSpaceDefaultTextColumn :title="field.data.email">
                    {{ field.data.email }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column field="login" :header="$t('login')" sortable>
                <template #body="field">
                  <ProSpaceDefaultTextColumn :title="field.data.login">
                    {{ field.data.login }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column
                field="securityLoginAuthenticateProvider"
                :header="$t('loginType')"
                sortable
              >
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.securityLoginAuthenticateProvider }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column field="comments" :header="$t('comments')" sortable>
                <template #body="field">
                  <ProSpaceDefaultTextColumn>
                    {{ field.data.comments }}
                  </ProSpaceDefaultTextColumn>
                </template>
              </Column>
              <Column field="createdAt" sortable :header="$t('createdDate')">
                <template #body="field">
                  <ProSpaceDateTimeColumn
                    :date="field.data.createdAt"
                    :dateFormat="userinfo.dateFormat"
                    :timeFormat="userinfo.timeFormat"
                  />
                </template>
              </Column>
              <Column field="actions" class="column-end column-end-30">
                <template #body="field">
                  <ProSpaceDots
                    :options="getRawDotsOptions([field.data])"
                    @action="(action) => handleDots(action, field.data)"
                  ></ProSpaceDots>
                </template>
              </Column>
            </template>
            <template #empty>
              <ProSpaceEmptyGrid
                icon="error-message"
                :title="$t('noDataTitle')"
                :text="$t('noDataTxt')"
              />
            </template>
          </ProSpaceMainGrid>
        </template>
      </ProSpaceGeoLayout>
      <ProSpaceGridModalForm
        v-model="showRoleModal"
        class="users-grid-role-modal"
        width="410"
        @apply:add="toAddingRoles($event)"
        @apply:delete="toDeletingRoles($event)"
        :service="roleService"
        :preService="securityUserRole"
        :filterModel="['systemName']"
        :id="masterId"
        :key="masterId"
        preGetMethod="get"
        :mappingField="modalFormMappingField"
        getMethod="grid"
        colName="systemName"
        colDesc="Name"
        :header="getTitleModalRole"
        :applyTxt="$t('applyTxt')"
        :cancelTxt="$t('cancelTxt')"
        :searchTxt="$t('searchTxt')"
        :showAll="true"
        :defaultFilter="{ disabled: { and: [false] } }"
        :showSearch="true"
        :isHeadHide="true"
      />
      <ModalUser ref="modal-user" @close="closeModalUser" />
      <ProSpaceFlashMessage
        v-model="showClearModal"
        :applyTxt="$t('confirmTxt')"
        :cancelTxt="$t('cancelTxt')"
        :title="$t('questClearFilters')"
        @apply="actionClear"
        @cancel="actionCancelClear"
        :needHideApply="false"
      >
        {{ $t('bodyClearFilters') }}
      </ProSpaceFlashMessage>
    </template>
    <template #right>
      <UserPanel
        v-if="hasSelect"
        :counter-roles="currentUserRoles?.length > 0 ? currentUserRoles.length : null"
        ref="right-panel"
        :service="userService"
        :key="JSON.stringify(selectedModel)"
        :model="selectedModel"
        :count="selectedCount"
        :clude="selectedClude"
        :options="rawDotsOptions"
        :is-all-rows-selected="isAllRowsSelected"
        @addRole="addRole($event)"
        @edit="editItem"
        @resetPasswordPanel="resetPassword"
        @delete-item="deleteItem"
        @history-item="showHistory"
        @clear="selectedMultipleReset"
        @clear:excluded="clearExcluded"
        @delete="onDeleteOneItem($event)"
        @apply:add="toAddingRoles($event)"
        @apply:delete="toDeletingRoles($event)"
      />
    </template>
  </ProSpaceGeoLayout>
  <ProSpaceHistoryModal
    ref="history"
    v-model="showHistoryModal"
    modelName="SecurityUserApiModel"
    @close="closeHistory"
  />
  <ModalBlockFilters />
</template>
<script>
import {
  ProSpaceFilterPanel,
  ProSpaceCustomFilterPanel,
  ProSpaceFilterSearchfield,
  ProSpaceMultiSelect,
  ProSpaceInputText,
  ProSpaceGridModalForm,
  ProSpaceMainGrid,
  ProSpaceDots,
  ModalForm,
  event_bus,
  ProSpaceGeoLayout,
  ProSpaceTopPanel,
  ProSpaceRightPanel,
  ProSpaceIconButton,
  ProSpaceButton,
  ProSpaceTableHeaderCell,
  ProSpaceEmptyGrid,
  ProSpaceDefaultTextColumn,
  ProSpaceFilterContainsChips,
  ProSpaceDateTimeColumn,
  ProSpaceFlashMessage
} from "@prospace/prospace-components-library";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import { mapGetters } from "vuex";
import { UserService } from "../../services/UserService.js";
import { AgencyService } from "../../../../AddressProgram/AddressProgram.Frontend/services/AgencyService";
import { RoleService } from "../../services/RoleService.js";
import { StatusService } from "../../services/StatusService.js";
import { LoginTypeService } from "../../services/LoginTypeService.js";
import { SecurityUserRole } from "../../services/SecurityUserRole.js";
import ModalUser from "./components/ModalUser.vue";
import PatchedCheckbox from "./PatchedCheckbox.vue";
import UserPanel from "./components/UserPanel";
import ProSpaceHistoryModal from "../../../../../Frontends/ProSpace/components/modals/ProSpaceHistoryModal.vue";
import accessMixin from "../../../../../Frontends/Common/utils/elementAccess/accessMixin";
import {
  useMultiSelectGrid,
} from "@composes/multiselect";
import ModalBlockFilters from "@multiselect/ModalBlockFilters"
import { ref } from "vue"
const _ = require("lodash");
export default {
  // mixins: [accessMixin],
  components: {
    ProSpaceFilterPanel,
    UserPanel,
    ProSpaceCustomFilterPanel,
    ProSpaceFilterSearchfield,
    ProSpaceMultiSelect,
    ProSpaceInputText,
    PatchedCheckbox,
    ProSpaceGridModalForm,
    ProSpaceMainGrid,
    DataTable,
    ProSpaceDots,
    ModalForm,
    Column,
    ProSpaceEmptyGrid,
    ProSpaceGeoLayout,
    ProSpaceTopPanel,
    ProSpaceRightPanel,
    ProSpaceIconButton,
    ProSpaceButton,
    ProSpaceTableHeaderCell,
    ModalUser,
    ProSpaceHistoryModal,
    ProSpaceDefaultTextColumn,
    ProSpaceFilterContainsChips,
    ProSpaceDateTimeColumn,
    ProSpaceFlashMessage,
    ModalBlockFilters,
  },
  setup() {
    const grid = ref(null)
    const filterPanel = ref(null)
    const {
      selectedMultipleGridHandler,
      selectedMultipleClear,
      selectedData,
      selectedCount,
      hasSelect,
      selectedMultipleBlockFilterHandler,
      needBlock,
      getRequestModel,
      selectedMultipleReset
    } = useMultiSelectGrid(grid, filterPanel)
    return {
      grid, filterPanel,
      selectedMultipleGridHandler, selectedData,
      hasSelect, selectedMultipleClear,
      selectedMultipleBlockFilterHandler,
      needBlock, selectedCount,
      getRequestModel, selectedMultipleReset
    }
  },
  data() {
    return {
      showHistoryModal: false,
      showRoleModal: false,
      // Grid Panel
      selectedModel: null,
      selectedCount: null,
      selectedClude: null,
      showClearModal: false,
      rawDotsOptions: [],
      spKey: 0,
      spHide: false,
      emitter: event_bus,
      panelModel: {},
      panelModels: [],
      tabCountField: "roles",

      modelTabPanel: { name: this.$t("overview") },

      // Service
      userService: new UserService(),
      roleService: new RoleService(),
      statusService: new StatusService(),
      securityUserRole: new SecurityUserRole(),
      loginTypeService: new LoginTypeService(),
      agencyService: new AgencyService(),

      //InlinePanel
      masterId: null,

      // Filter Panel Model
      modelFastFilter: {
        label: this.$t("allTxt"),
        value: false,
        field: "disabled",
      },
      currentUserRoles: [],
      modalFormMappingField: "securityRoleId",
      isAllRowsSelected: false,
      autoWidthStatusId: false,
    };
  },
  watch: {
    masterId: {
      handler: function(val) {
        if (val) this.getUserRoles();
      }
    },
    immediate: true
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    customServices() {
      return [
        {
          type: "number",
          model: "id",
          label: this.$t("id"),
          selected: {},
        },
        {
          type: "checkboxes",
          service: new RoleService(),
          getMethod: "grid",
          model: "securityRoleId",
          label: this.$t("role"),
          optionValue: "id",
          optionLabel: "systemName",
          defaultFilter: { disabled: false },
          selected: {},
        },
        {
          type: "chips",
          model: "createdBy",
          label: this.$t("createdByTxt"),
          selected: {},
        },
        {
          type: "chips",
          model: "updatedBy",
          label: this.$t("updatedByTxt"),
          selected: {},
        },
        {
          type: "dates-range-time",
          model: "createdAt",
          label: this.$t("createDate"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
        {
          type: "dates-range-time",
          model: "lastUpdated",
          label: this.$t("lastUpdatedTxt"),
          optionValue: "date",
          selected: {},
          dateFormat: this.userinfo.dateFormat,
        },
      ];
    },
    dotsOptions() {
      let res = [
        {
          name: "edit",
          text: this.$t("editItemTxt"),
          icon: "edit",
          method: this.editItem,
        },
        {
          name: "resetPassword",
          text: this.$t("resetPasswordB"),
          icon: "lock",
          method: this.resetPassword,
        },
        {
          name: "delete",
          text: this.$t("delete"),
          icon: "delete",
          method: this.deleteItem,
        },
        {
          name: "showHistory",
          text: this.$t("history"),
          icon: "history",
          method: this.showHistory,
        },
      ];
      if (this.modelFastFilter.label === this.$t("deleted")) {
        return res.filter(
          (option) =>
            option.name !== "edit" &&
            option.name !== "delete" &&
            option.name !== "resetPassword"
        );
      }
      return res;
    },
    dotsHeaderOptions() {
      return [
        { name: "export_csv", text: this.$t("export_csv"), icon: "upload" },
        { name: "export_xlsx", text: this.$t("export_xlsx"), icon: "upload" },
      ];
    },
    fastFilters() {
      return [
        {
          label: this.$t("allTxt"),
          value: false,
          field: "disabled",
        },
        { label: this.$t("active"), field: "status", value: "ACTIVE" },
        { label: this.$t("deleted"), field: "disabled", value: true },
      ];
    },
    disabledModalRule() {
      return (
        this.modalModel.firstName.length == 0 ||
        this.modalModel.lastName.length == 0
      );
    },
    isDeletedTab() {
      return this.modelFastFilter.label === this.$t("deleted");
    },
    spShow() {
      return this.selectedModel.length > 0;
    },
    spVisible() {
      return this.selectedModel.length > 0;
    },
    getTitleModalRole() {
      return this.$t('add') + " " + this.$t('roleLower');
    },
    tabsPanel() {
      return [
        { name: "Overview", displayName: this.$t("overview") },
        {
          name: "Roles",
          displayName: this.$t("roles"),
          count: this.panelModel[this.tabCountField]
            ? this.panelModel[this.tabCountField].length
            : null,
        },
      ];
    },
  },
  methods: {
    checkIsAllRowsSelected() {
      this.$nextTick(() => {
        this.isAllRowsSelected = this.grid.isAllRowsSelected
      })
    },
    handlerBlockFilterPanel({ tab }) {
      this.showClearModal = true
      this.actionClear = () => {
        this.selectedMultipleClear()
        if (tab) {
          this.filterPanel.fastFilter = tab
        }
        this.$nextTick(() => {
          this.filterPanel.submitFilter()
          this.showClearModal = false
        })
      }
      this.actionCancelClear = () => {
        this.showClearModal = false
      }
    },
    getRawDotsOptions(records) {
      if (
        records.every((x) => x.securityLoginAuthenticateProvider === "Cookies")
      )
        return this.dotsOptions;

      return this.dotsOptions.filter((o) => o.name !== "resetPassword");
    },
    handleDots(action, item) {
      var option = this.dotsOptions.find((o) => o.name === action);
      option.method(item);
    },
    handleHeaderDots(action) {
      if (action === "export_csv") {
        this.actionExport("CSV");
      } else if (action === "export_xlsx") {
        this.actionExport("XLSX");
      }
    },
    closeHistory() {
      this.showHistoryModal = false;
    },
    closeModalUser() {
      this.$refs["modal-user"].show = false;
      this.actionUpdate();
    },
    showHistory(record) {
      this.$refs.history.tabs[0].masterId = record.id;
      this.$refs.history.masterName = record.secondName
        ? `${record.lastName} ${record.firstName} ${record.secondName}`
        : `${record.lastName} ${record.firstName}`;
      this.$nextTick(() => {
        this.showHistoryModal = true;
      });
    },
    resetPassword(record) {
      const requestModel = this.getRequestModel(record)

      if (this.selectedCount > 5) {
        this.userService.resetPasswordBackground(requestModel);
        return;
      }

      this.userService.resetPassword(requestModel).then((res) => {
        if (res && res.success) {
          this.$store
            .dispatch("notifications/addNotification", {
              logLevel: "Information",
              title: this.$t("passwordChanged"),
              messageData: {
                Title: "passChange",
                Record: { Id: this.selectedData?.id || record?.id },
              },
            })
            .then((mi) => {
              this.$store.dispatch("notifications/updateReadedRecord", {
                title: mi.messageData.Title,
                id: mi.messageData.Record.Id,
              });
            });
        }
      });
    },
    toItem(data) {
      this.$router.push(`/securityadmin/user/${data.id}`);
    },
    submitFilter({ filter, search }) {
      filter.securityUserRoleDisabled =
        filter &&
        filter.securityRoleId &&
        filter.securityRoleId.or &&
        !!filter.securityRoleId.or.length
          ? { or: [false] }
          : null;

      this.grid.submitFilter(filter, search);
    },
    emitFilter() {
      this.filterPanel.submitFilter();
    },
    clear() {
      if (this.grid) {
        this.selectedModel = null;
        this.selectedCount = null;
        this.selectedClude = null;
        this.grid.selectedModel = [];
        this.grid.clickedItem = null;
        this.grid.isAllRowsSelected = false;
      }
    },
    clearExcluded() {
      if (this.grid) {
        this.selectedModel = null;
        this.selectedCount = this.grid?.records.length;
        this.selectedClude = {
          items: [],
          isAll: true
        };
        this.grid.selectedModel = [];
        this.grid.isAllRowsSelected = true;
      }
    },
    customFilterApply(filter, model) {
      filter = Object.assign(filter, model);
      this.emitFilter();
    },
    actionUpdate(updateRightPanel = true) {
      this.grid.getRecords(true);
      if (this.$refs["right-panel"] && updateRightPanel) {
        this.$refs["right-panel"].update();
      }
    },
    async actionExport(format) {
      this.loadingHandler(true);
      await this.userService.export(
        this.grid.getRecords(false, true),
        format
      );
      this.loadingHandler(false);
    },
    afterLoadHanlder(model) {
      if (typeof model == "object") {
        this.panelModel = model;
      } else {
        this.panelModels = model;
      }
    },
    selectedHandler(val) {
      this.checkIsAllRowsSelected();
      const selectedModel = this.grid.getSelectedModel()
      this.rawDotsOptions = this.getRawDotsOptions(selectedModel);

      this.selectedMultipleGridHandler(val)
      this.masterId = val?.data?.id;
    },
    showChangeModal() {
      this.$refs["modal-user"].init();
    },
    deleteItem(model) {
      const requestModel = this.getRequestModel(model);

      const grid = this.$refs["grid"];
      grid.setLoading(true);

      this.userService.delete(requestModel).then(() => {
        this.actionUpdate();
        grid.setLoading(false);
      });
    },
    editItem(model) {
      if (!model) return;
      this.$refs["modal-user"].init(model);
    },
    sendGridModal(mappingModel) {
      if (!Array.isArray(mappingModel)) {
        mappingModel = [mappingModel];
      }
      const rightPanel = this.$refs["right-panel"];
      const user = rightPanel.user;

      const me = this;
      const currentRoleIds = this.currentUserRoles.map(
        (role) => role[this.modalFormMappingField]
      );
      const roleIds = mappingModel.map((role) => role.id);
      const delIdRoles = _.difference(currentRoleIds, roleIds); // del
      const addIdRoles = _.difference(roleIds, currentRoleIds); // add

      if (delIdRoles.length > 0) {
        const deletingRoles = [];
        delIdRoles.forEach((id) => {
          const r = me.currentUserRoles.find(
            (role) => id === role[me.modalFormMappingField]
          );
          if (r) {
            deletingRoles.push(me.securityUserRole.delete(r));
          }
        });
        if (deletingRoles.length > 0) {
          Promise.all(deletingRoles).then(() => {
            rightPanel.refreshRoleList();
          });
        }
      }
      if (addIdRoles.length > 0) {
        const creatingRoles = mappingModel.filter((role) =>
          addIdRoles.includes(role["id"])
        );

        this.securityUserRole.create(user, creatingRoles).then(() => {
          rightPanel.refreshRoleList();
        });
      }

      this.$refs["right-panel"].update();
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      switch (status) {
        case "ACTIVE":
          type = "success";
          break;
        case "NEW":
          type = "info";
          break;
        default:
          type = "danger";
      }
      return {
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
        type,
      };
    },
    loadingHandler(val) {
      this.grid.loading = val;
    },
    addRole() {
      this.showRoleModal = true;
    },
    async toDeletingRoles(roles) {
      const rightPanel = this.$refs["right-panel"];
      const me = this;
      const deletingRoles = [];
      const isUserRoles = roles.every(r => r.securityUserId)

      roles.forEach((r) => {
        const deletingRole = me.currentUserRoles.find(o => o[this.modalFormMappingField] === r.id);
        if (deletingRole && !isUserRoles) {
          deletingRoles.push(deletingRole);
        } else {
          deletingRoles.push(r);
        }
      });
      await me.securityUserRole.delete(deletingRoles);
      await this.getUserRoles();
      await rightPanel?.refreshRoleList();
      this.updateUserPanel();
    },
    async toAddingRoles(roles) {
      const rightPanel = this.$refs["right-panel"];
      const user = rightPanel.user;

      await this.securityUserRole.create(user, roles);
      await this.getUserRoles();
      await rightPanel?.refreshRoleList();
      this.updateUserPanel();
    },
    updateUserPanel() {
      this.$refs["right-panel"].update();
    },
    async getUserRoles() {
      try {
        const res = await this.securityUserRole.get(this.masterId);
        this.currentUserRoles = res?.data?.length > 0 ? res.data : [];
      } catch (e) {
        console.error(e);
      }
    },
    async onDeleteOneItem(item) {
      await this.getUserRoles();
      this.updateUserPanel();
    },
    onLoadGrid() {
      this.$nextTick(() => {
        this.hasSelect = false;
      })
    }
  },
};
</script>
<style lang="scss">
.users-grid-role-modal {
  .prospace-filter-panel {
    &__second-row {
      overflow: hidden;
      background-color: var(--prospace-ui-bg);
      & > .prospace-h-layout{
        &:first-child {
          min-width: 100% !important;
        }
      }
    }
  }
  .main-grid {
    tbody {
      tr {
        height: 40px !important;
        td {
          &:nth-child(2) {
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
  }
}
</style>
